import "./src/styles/global.css"
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/js/bootstrap"

const React = require("react")